<template>
  <div class="main-container min-vh-100">
    <div v-if="loaded" class="summary-box mt-5">
      <p @click="cancelMarkPageHandler" class="cancel-mark">X</p>
      <p class="summary-title">{{ $helpers.translate(data.title, lang) }}</p>
      <CRow class="container-content">
        <!-- <div
          :key="index"
          v-for="(item, index) in progress"
          class="text-center"
        >
          <p v-if="item.progress > 0">{{item.description}}</p>
          <p v-else>xxxxxxxxxxxxxx</p>
        </div> -->
        <CCol
          :key="index"
          v-for="(item, index) in progress"
          class="text-center"
        >
          <div
            v-if="item.progress > 0"
            :style="{
              color:
                btnStyle[$helpers.translate(item.description, lang)].enable.textColor,
            }"
          >
            <a
              class="status-circle-display score-display pointer"
              :style="{
                'box-shadow':
                  btnStyle[$helpers.translate(item.description, lang)].enable
                    .boxShadow,
              }"
              @click="onLink($helpers.translate(item.description, lang))"
            >
              <label class="mb-0 font-xl">{{ item.score.toFixed(2) }}</label>
              EXP
            </a>
            <p class="summary-menu-name text-uppercase mt-2">
              {{ $helpers.translate(item.description, lang) }}
            </p>
          </div>

          <div
            v-else
            :style="{
              color:
                btnStyle[$helpers.translate(item.description, lang)].disable
                  .textColor,
            }"
          >
            <a
              class="status-circle-display score-display"
              :style="{
                'box-shadow':
                  btnStyle[$helpers.translate(item.description, lang)].disable
                    .boxShadow,
              }"
            >
              <label class="mb-0 font-xl">{{ item.score.toFixed(2) }}</label>
              EXP
            </a>
            <p class="summary-menu-name text-uppercase mt-2">
              {{ $helpers.translate(item.description, lang) }}
            </p>
          </div>
        </CCol>
      </CRow>
    </div>
    <div class="button-container mt-5 mb-5">
      <button class="btn btn-cpr btn-next" @click="nextChapter">
        {{ $helpers.translate(this.nextChapterText, lang) }}&nbsp;>>>
      </button>
    </div>
    <div class="cartoon-image-container">
      <img v-if="mascot" :src="mascot" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "Summary",

  data() {
    return {
      mascot: "",
      baseUrl: process.env.VUE_APP_URL_SOUND,
      loaded: false,
      progress: [],
      courseCode: "",
      data: [],
      lang: "th",
      action: [],
      btnStyle: [],
      templateId: "",
      startTime: "",
      courseSection: "",
      checkProgressCond: "",
      lang: "th",
      nextChapterText: "",
      isClick : false
    };
  },
  computed: {
    ...mapGetters({
      templateContent: "template/getTemplateContent",
      getCourseProgress: "courses/getCourseChapterAndProgress",
      loadingGetter: "template/loadingGetter",
    }),
  },
  watch: {
    templateContent: function (val) {
      if (!val.enable) {
        this.$router.push({ name: val.navigate.close.action });
      } else {
        this.data = val;
        this.nextChapterText = this.data.navigate.next.title;
        this.templateId = val._id;
        this.mascot = this.baseUrl + "/cpr/Image/mascotDoubt.gif";
        this.courseSection = this.$store.getters[
          "necessary/getLerningCourse"
        ].groups[0].code;
        this.loaded = true;

        this.data.content.item.forEach((element) => {
          if (element.comment == "active") {
            this.checkProgressCond = this.$helpers.translate(
              element.message,
              this.lang
            );
          }
          this.btnStyle[this.$helpers.translate(element.message, this.lang)] =
            element.button.style;
          this.action[this.$helpers.translate(element.message, this.lang)] =
            element.button.action;
        });
        this.$store.dispatch("template/createUserTemplateData", {
          code: this.courseCode,
          template: this.templateId,
          section: this.courseSection,
        });
      }
    },
    loadingGetter: function (val) {
      if (val == true && this.isClick == true) {
        this.$router.push({
          name: "CPRpreview",
          params: { id: this.data.navigate.next.action },
        });
      }
    },
    getCourseProgress: function (val) {
      console.log(val);
      val.template.forEach((pg) => {
        if (pg.percent != 0 && pg.percent != undefined) {
          this.progress.push(pg);
          //console.log('progress:',pg.code,pg.percent,pg.score);
          console.log(this.progress);
        }
      });
    },
  },
  created() {
    this.courseCode = this.$store.getters["necessary/getLerningCourse"]._id;
    this.startTime = this.$helpers.getDateFormat();
  },
  mounted() {
    let body = {};
    body.code = this.courseCode;
    body.templateCode = this.$route.params.id;
    this.$store.dispatch("template/fetchContent", body);
    this.$store.dispatch(
      "courses/fetchCourseChapterAndProgress",
      this.courseCode
    );
  },
  methods: {
    cancelMarkPageHandler() {
      this.$router.push({
        name: this.data.navigate.close.action,
      });
    },
    nextChapter() {
      this.isClick = true;
      this.$store.dispatch("template/saveUserTemplateData", {
        code: this.courseCode,
        template: this.templateId,
        section: this.courseSection,
        answering: [],
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        condition: [],
      });
    },
    onLink(key) {
      this.$router.push({
        name: this.action[key],
      });
    },
  },
};
</script>

<style scoped>
@import "../../assets/scss/CPR/style.scss";
.summary-menu-name {
  font-size: 0.8rem;
  margin-top: 5px;
}
.score-display {
  font-size: 1rem;
  font-weight: 500;
}
.cartoon-image-container {
  position: absolute;
  left: 10%;
  top: 20%;
  width: 20rem;
  height: auto;
}

.cartoon-image-container img {
  object-fit: fill;
  width: 100%;
  height: 100%;
  max-width: auto;
  max-height: auto;
}

.button-container {
  text-align: center;
}

.button-container .button {
  outline: none;
  padding: 1rem 3rem;
}

.main-container {
  overflow-y: hidden;
  overflow: hidden;
  padding-top: 6.875rem;
  left: 0px;
  width: 100%;
  height: 100%;
  /* min-height: 100vh; */
  background-repeat: no-repeat;
  background-size: auto;
  /* background: transparent linear-gradient(224deg, #ffffff00 0%, #00000038 100%)
    0% 0% no-repeat padding-box; */
    background: #f3f3f3;
}

.main-container .summary-box {
  text-align: center;
  margin: auto;
  width: 40%;
  height: auto;
  min-height: 27.8125rem;
  box-shadow: 5px 8px 36px #a9f1df;
  border: 4px solid #ffffff33;
  border-radius: 30px;
  opacity: 1;
}

.main-container .summary-box .cancel-mark {
  float: right;
  margin-right: -1.25rem;
  font-size: 1.35rem;
  margin-top: -1.25rem;
}

.main-container .summary-box .cancel-mark:hover {
  cursor: pointer;
}

.main-container .summary-box .summary-title {
  margin-bottom: 5.6875rem;
  margin-top: 2.625rem;
  text-align: center;
  font-size: 2.6rem;
  font-weight: 100;
  letter-spacing: 1px;
  color: #38adae;
  opacity: 1;
}

.main-container .summary-box .container-content {
  padding: 0px 4.5625rem;
}

.main-container .summary-box .status-circle-display {
  margin: auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: auto;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: transparent
    linear-gradient(312deg, #f2f2f2 0%, #eaeaea 27%, #b2b2b2 92%, #797979 100%)
    0% 0% no-repeat padding-box;
  border: 4px solid #f2f2f2;
  opacity: 1;
}
.pointer,
.pointer * {
  cursor: pointer;
}

@media screen and (max-width: 1440px) {
  .summary-box {
    width: 60% !important;
  }
  .cartoon-image-container {
    left: 0;
    top: 10%;
  }
}
@media screen and (max-width: 768px) {
  .main-container .summary-box {
    width: 90% !important;
  }
  .cartoon-image-container {
    left: -1rem;
    width: 12rem;
    height: 24rem;
  }
}

@media screen and (max-width: 480px) {
  .cartoon-image-container {
    position: absolute;
    /* left: 5rem;
    bottom: 20rem; */
    left: -2rem;
    bottom: 0rem;
    width: 12rem;
    height: 20rem;
  }

  .main-container {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .main-container .summary-box {
    width: 100%;
    height: 100%;
  }
  .main-container .summary-box .cancel-mark {
    float: right;
    margin-right: -0.5rem;
    font-size: 1.35rem;
    margin-top: -1.75rem;
  }

  .main-container .summary-box .container-content {
    padding: 0px 0.75rem;
    margin-bottom: 3rem;
  }

  .main-container .summary-box .summary-title {
    font-size: 2rem;
    margin-bottom: 3rem;
  }

  .main-container .summary-box .status-circle-display {
    margin: auto;
    width: 4.375rem;
    height: 4.375rem;
    border-radius: 50%;
  }
}
</style>